import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa6bd970"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center text-2xl" }
const _hoisted_2 = { class: "hop-dong-form-wrapper" }
const _hoisted_3 = { class: "wizard wizard-1" }
const _hoisted_4 = { class: "wizard-nav border-bottom" }
const _hoisted_5 = { class: "wizard-steps p-4 p-lg-6" }
const _hoisted_6 = ["data-wizard-state", "onClick", "onKeyup"]
const _hoisted_7 = { class: "wizard-label" }
const _hoisted_8 = { class: "wizard-title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("polygon", { points: "0 0 24 0 24 24 0 24" }),
    /*#__PURE__*/_createElementVNode("rect", {
      fill: "#000000",
      opacity: "0.3",
      transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000)",
      x: "11",
      y: "5",
      width: "2",
      height: "14",
      rx: "1"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z",
      fill: "#000000",
      "fill-rule": "nonzero",
      transform: "translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)"
    })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "flex justify-center gap-x-1 mt-5 pb-5 flex-wrap" }
const _hoisted_12 = { class: "mt-8" }

import { computed, nextTick, onMounted, reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import moment from "moment";
import { ElForm, ElInput, ElSelect } from "element-plus";

import ConfirmationDialog from "@/components/confirmation-dialog/ConfirmationDialog.vue";
import {
  buildHopDongCreatePayload,
  buildHopDongUpdatePayload,
  HopDongHdvtStep,
  HopDongMetaStep,
  useHopDongFormMode,
  useHopDongHdvtLines,
  useHopDongWizard,
} from "@/components/hop-dong";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import Pagination from "@/components/shared/pagination/Pagination.vue";
import { getGlobalDefaultDate } from "@/core/config/DatePickerConfig";
import {
  setBreadcrumbLinks,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import {
  formatContractNumber,
  getErrorMsg,
  swalErrNotification,
  swalNotification,
  validatePhoneNumber,
  validateTaxNumber,
} from "@/core/helpers/utils";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import useFormInput from "@/core/hooks/use-form-input";
import { useLoading } from "@/core/hooks/use-loading";
import { usePagination } from "@/core/hooks/use-pagination";
import { useRouterCustom } from "@/core/hooks/use-router-custom";
import type {
  AccountantItemResponse,
  IBienBanResponseBase,
  IHopDongResponseBase,
  ITaiKhoanKeToanResponse,
} from "@/core/interfaces/ApiResponses";
import { resolveListPageForRoute } from "@/core/helpers/list-page-context";
import { HopDongService } from "@/core/services/HopDong.service";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import type { HopDongFormFields, HopDongWizardStep } from "@/types/hop-dong";
import HopDongTable from "@/views/crafted/pages/hop-dong/hop-dong-table/HopDongTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { replace, id } = useRouterCustom();
const contractId = computed(() => {
  const fromRoute = Number(route.params.id);

  return fromRoute > 0 ? fromRoute : id.value;
});
const { startLoading, endLoading } = useLoading();
const { formConfig, isCreating } = useHopDongFormMode(route);
const { ButtonTypeColors, ButtonsType } = useButtonCustom();
const { currentPage, perPage, totalItems } = usePagination();
currentPage.value = resolveListPageForRoute(route.query, {
  isCreate: isCreating.value,
});
const { focusFirstErrInputV2 } = useFormInput();

const {
  lines,
  clearLines,
  hydrateFromHopDongVatTu,
  addExistingFromVatTu,
  removeLine,
  patchLine,
} = useHopDongHdvtLines();

const formRef = ref<InstanceType<typeof ElForm> | null>(null);
const contractNumberInputRef = ref<InstanceType<typeof ElInput>>();
const signDatePickerRef = ref<{ focus?: () => void } | null>(null);
const expiryDatePickerRef = ref<{ focus?: () => void } | null>(null);
const loaiHopDongSelectRef = ref<InstanceType<typeof ElSelect>>();
const soHoaDonInputRef = ref<InstanceType<typeof ElInput>>();
const taxNumberInputRef = ref<InstanceType<typeof ElInput>>();
const partnerNameInputRef = ref<InstanceType<typeof ElInput>>();
const phoneNumberInputRef = ref<InstanceType<typeof ElInput>>();
const addressInputRef = ref<InstanceType<typeof ElInput>>();

const contract = reactive({
  bien_ban_kiem_nghiem: [] as IBienBanResponseBase[],
  contractNumber: "",
  signDate: "",
  expiryDate: "",
  partnerName: "",
  phoneNumber: "",
  address: "",
  taxNumber: "",
  loai_hop_dong: 1,
  so_hoa_don: "",
});

const loaiHopDongOptions = [
  { label: "Hợp đồng mua bán", value: 1 },
  { label: "Hợp đồng điều chỉnh", value: 2 },
];

const isConfirmationDialogOpen = ref(false);
const isNoExpiration = ref(false);
const shouldContinueAfterSave = ref(false);
const hopDongItems = ref<IHopDongResponseBase[]>([]);

const createDefaultTkKetoan = (): ITaiKhoanKeToanResponse => ({
  id: 0,
  matk: "",
  mact: "",
  tentk: "",
});

const taiKhoanData = ref<ITaiKhoanKeToanResponse>(createDefaultTkKetoan());

const mapAccountantToTkKetoan = (
  item: AccountantItemResponse
): ITaiKhoanKeToanResponse => ({
  id: item.id,
  matk: item.ma_tai_khoan,
  mact: item.ma_chi_tiet?.toString() ?? "",
  tentk: item.ten_tai_khoan,
  id_don_vi: item.id_don_vi,
  nam: item.nam,
  dia_chi: item.dia_chi ?? undefined,
  phan_cap: item.phan_cap,
  cap_so: item.cap_so,
  requested_at: moment().format("YYYY-MM-DD HH:mm:ss"),
});

const applyTkKetoanToContract = (tkKetoan: ITaiKhoanKeToanResponse) => {
  contract.taxNumber = tkKetoan.mact;
  contract.partnerName = tkKetoan.tentk;

  if (tkKetoan.dia_chi) {
    contract.address = tkKetoan.dia_chi;
  }
};

const confirmTitle = computed(() =>
  isCreating.value
    ? formConfig.value.confirmCreateTitle
    : formConfig.value.confirmUpdateTitle
);

const validateMetaStep = (): Promise<boolean> =>
  new Promise((resolve) => {
    if (!formRef.value) {
      resolve(false);

      return;
    }

    formRef.value.validate(async (valid) => {
      if (!valid) {
        await focusFirstErrInputV2();
        resolve(false);

        return;
      }

      if (!taiKhoanData.value.matk || !taiKhoanData.value.mact) {
        await swalNotification(
          "Bắt buộc phải nhập thông tin tài khoản",
          "error"
        );
        resolve(false);

        return;
      }

      resolve(true);
    });
  });

const {
  step,
  steps,
  currentStepMeta,
  isMetaStep,
  isHdvtStep,
  goToHdvt: advanceToHdvt,
  goBack,
  resetWizard,
} = useHopDongWizard({
  onBeforeLeaveMeta: validateMetaStep,
});

const goToHdvt = async () => {
  await advanceToHdvt();
};

const onStepClick = async (target: HopDongWizardStep) => {
  if (target === "hdvt") {
    await goToHdvt();

    return;
  }

  goBack();
};

const wizardStepState = (item: { id: HopDongWizardStep; index: number }) => {
  if (item.id === step.value) {
    return "current";
  }

  if (item.index < currentStepMeta.value.index) {
    return "done";
  }

  return "pending";
};

const contractNumberValidator = (_rule, value, fn) => {
  setTimeout(() => {
    if (!value?.trim()) {
      fn(new Error("Bắt buộc phải nhập số hợp đồng"));

      return;
    }

    if (value && !/^[A-Z0-9\s]*$/.test(value)) {
      fn(new Error("Số hợp đồng chỉ được chứa số, chữ in hoa và khoảng trắng"));

      return;
    }

    fn();
  }, 500);
};

const isPhoneNumber = (_rule, value, fn) => {
  if (value && value.trim() !== "") {
    if (!validatePhoneNumber(value)) {
      return fn(new Error("Số điện thoại không đúng định dạng"));
    }
  }

  fn();
};

const isTaxNumber = (_rule, value, fn) => {
  if (value && !validateTaxNumber(value)) {
    return fn(
      new Error("Mã số thuế không đúng định dạng (7, 10, 12, hoặc 14 ký tự)")
    );
  }

  fn();
};

const expiredDateValidation = (_rule, value, callback) => {
  if (!value && isNoExpiration.value === false) {
    callback(new Error("Ngày hết hạn không được bỏ trống"));

    return;
  }

  if (value && contract.signDate && moment(contract.signDate).isAfter(value)) {
    callback(new Error("Ngày hết hạn không được trước ngày ký"));

    return;
  }

  callback();
};

const signedDateValidation = (_rule, value, callback) => {
  if (
    value &&
    contract.expiryDate &&
    moment(value).isAfter(contract.expiryDate)
  ) {
    callback(new Error("Ngày hết hạn không được trước ngày ký"));

    return;
  }

  callback();
};

const validationRules = ref({
  contractNumber: [{ validator: contractNumberValidator, trigger: "blur" }],
  signDate: [
    {
      required: true,
      message: "Bạn phải nhập ngày ký hợp đồng",
      trigger: "change",
    },
    { validator: signedDateValidation, trigger: "change" },
  ],
  expiryDate: [{ validator: expiredDateValidation, trigger: "blur" }],
  partnerName: [
    {
      required: true,
      message: "Tên đối tác là bắt buộc",
      trigger: "blur",
    },
  ],
  phoneNumber: [
    { validator: isPhoneNumber, trigger: "blur" },
    { validator: isPhoneNumber, trigger: "change" },
  ],
  taxNumber: [
    {
      required: true,
      message: "Mã số thuế là bắt buộc phải nhập",
      trigger: "blur",
    },
    { validator: isTaxNumber, trigger: "blur" },
    { validator: isTaxNumber, trigger: "change" },
  ],
});

const patchContract = (patch: Partial<typeof contract>) => {
  Object.assign(contract, patch);
};

const onSetMetaRef = (name: string, el: unknown) => {
  if (!el) {
    return;
  }

  switch (name) {
    case "contractNumber":
      contractNumberInputRef.value = el as InstanceType<typeof ElInput>;
      break;
    case "signDate":
      signDatePickerRef.value = el as { focus?: () => void };
      break;
    case "expiryDate":
      expiryDatePickerRef.value = el as { focus?: () => void };
      break;
    case "loaiHopDong":
      loaiHopDongSelectRef.value = el as InstanceType<typeof ElSelect>;
      break;
    case "soHoaDon":
      soHoaDonInputRef.value = el as InstanceType<typeof ElInput>;
      break;
    case "taxNumber":
      taxNumberInputRef.value = el as InstanceType<typeof ElInput>;
      break;
    case "partnerName":
      partnerNameInputRef.value = el as InstanceType<typeof ElInput>;
      break;
    case "phoneNumber":
      phoneNumberInputRef.value = el as InstanceType<typeof ElInput>;
      break;
    case "address":
      addressInputRef.value = el as InstanceType<typeof ElInput>;
      break;
    default:
      break;
  }
};

const focusContractNumberInput = async () => {
  await nextTick();
  contractNumberInputRef.value?.focus();
  contractNumberInputRef.value?.select?.();
};

const focusSignDatePicker = async () => {
  await nextTick();
  signDatePickerRef.value?.focus?.();
};

const focusExpiryDatePicker = async () => {
  if (isNoExpiration.value) {
    return;
  }

  await nextTick();
  expiryDatePickerRef.value?.focus?.();
};

const focusLoaiHopDongSelect = async () => {
  if (contract.bien_ban_kiem_nghiem.length > 0) {
    return;
  }

  await nextTick();
  loaiHopDongSelectRef.value?.focus?.();
};

const focusSoHoaDonInput = async () => {
  await nextTick();
  soHoaDonInputRef.value?.focus();
  soHoaDonInputRef.value?.select?.();
};

const focusTaxNumberInput = async () => {
  await nextTick();
  taxNumberInputRef.value?.focus();
  taxNumberInputRef.value?.select?.();
};

const focusPartnerNameInput = async () => {
  await nextTick();
  partnerNameInputRef.value?.focus();
  partnerNameInputRef.value?.select?.();
};

const focusPhoneNumberInput = async () => {
  await nextTick();
  phoneNumberInputRef.value?.focus();
  phoneNumberInputRef.value?.select?.();
};

const focusAddressInput = async () => {
  await nextTick();
  addressInputRef.value?.focus();
  addressInputRef.value?.select?.();
};

const onNoExpirationChange = (checked: boolean) => {
  isNoExpiration.value = checked;

  if (checked) {
    contract.expiryDate = "";
  }
};

const toggleNoExpiration = () => {
  onNoExpirationChange(!isNoExpiration.value);
};

const getDefaultContractState = () => ({
  bien_ban_kiem_nghiem: [] as IBienBanResponseBase[],
  contractNumber: "",
  signDate: "",
  expiryDate: "",
  partnerName: "",
  phoneNumber: "",
  address: "",
  taxNumber: "",
  loai_hop_dong: 1,
  so_hoa_don: "",
});

const clearForm = async () => {
  const defaultContractState = getDefaultContractState();

  Object.assign(contract, defaultContractState);
  isNoExpiration.value = false;
  taiKhoanData.value = createDefaultTkKetoan();
  clearLines();
  resetWizard();

  await nextTick();
  formRef.value?.clearValidate(Object.keys(defaultContractState));
  await focusContractNumberInput();
};

const buildHopDongFields = (): HopDongFormFields => {
  const signDate = moment(contract.signDate).format("YYYY/MM/DD");
  const expiryDate = isNoExpiration.value
    ? ""
    : moment(contract.expiryDate).format("YYYY/MM/DD");

  return {
    so_hop_dong: contract.contractNumber,
    ngay_ky: signDate,
    ngay_het_han: expiryDate,
    ten_doi_tac: contract.partnerName,
    ...(contract.phoneNumber ? { so_dien_thoai: contract.phoneNumber } : {}),
    ...(contract.address ? { dia_chi: contract.address } : {}),
    ma_so_thue: contract.taxNumber,
    loai_hop_dong: contract.loai_hop_dong,
    ...(contract.so_hoa_don ? { so_hoa_don: contract.so_hoa_don } : {}),
    tk_ketoan: { ...taiKhoanData.value },
  };
};

const fetchHopDongList = async () => {
  try {
    startLoading();

    const {
      data: {
        data: { data, total },
      },
    } = await HopDongService.fetchAllContracts({
      current_page: currentPage.value,
      per_page: perPage.value,
    });

    hopDongItems.value = data;
    totalItems.value = total;
    endLoading();
  } catch (error) {
    endLoading();

    await swalNotification(
      getErrorMsg(
        error,
        "Xin lỗi, có vẻ có lỗi xảy ra khi tải danh sách hợp đồng"
      ),
      "error"
    );
  }
};

const refreshFirstPage = async () => {
  if (currentPage.value !== 1) {
    currentPage.value = 1;

    return;
  }

  await fetchHopDongList();
};

const onOpenConfirmationDialog = async (shouldContinue = false) => {
  const metaOk = await validateMetaStep();

  if (!metaOk) {
    resetWizard();

    return;
  }

  shouldContinueAfterSave.value = shouldContinue;
  isConfirmationDialogOpen.value = true;
};

const onSubmit = async () => {
  isConfirmationDialogOpen.value = false;

  const hopDong = buildHopDongFields();

  try {
    let savedHopDongId = contractId.value;

    if (isCreating.value) {
      const {
        data: { data },
      } = await HopDongService.create(
        buildHopDongCreatePayload({
          hopDong,
          lines: lines.value,
        })
      );

      savedHopDongId = data.id;
    } else {
      await HopDongService.update(
        contractId.value,
        buildHopDongUpdatePayload({
          hopDong,
          lines: lines.value,
        })
      );
    }

    await swalNotification(
      isCreating.value
        ? formConfig.value.submitCreateMessage
        : formConfig.value.submitUpdateMessage
    );

    if (shouldContinueAfterSave.value && isCreating.value) {
      await clearForm();
      await refreshFirstPage();

      return;
    }

    await router.replace({
      name: "chi-tiet-hop-dong",
      params: {
        id: String(savedHopDongId),
      },
    });
  } catch (error) {
    await swalNotification(
      getErrorMsg(
        error,
        `Xin lỗi, không thể ${
          isCreating.value ? "tạo mới" : "chỉnh sửa"
        } hợp đồng, mời bạn thực hiện lại`
      ),
      "error"
    );
  }
};

const onSelectTaiKhoan = ({
  taiKhoanItem,
}: {
  taiKhoanItem: AccountantItemResponse;
}) => {
  const tkKetoan = mapAccountantToTkKetoan(taiKhoanItem);

  taiKhoanData.value = {
    ...taiKhoanData.value,
    ...tkKetoan,
  };

  if (taiKhoanData.value.mact) {
    applyTkKetoanToContract(taiKhoanData.value);
  }
};

const onClearTaiKhoan = (type: "tai_khoan" | "chi_tiet") => {
  if (type === "tai_khoan") {
    taiKhoanData.value = createDefaultTkKetoan();
    return;
  }

  taiKhoanData.value = {
    ...taiKhoanData.value,
    mact: "",
  };
};

const getHttpErrorStatus = (error: unknown): number | undefined => {
  const err = error as {
    response?: { status?: number; data?: { status?: number } };
  };

  return err?.response?.data?.status ?? err?.response?.status;
};

const redirectToHopDongDetail = async (detailId: number) => {
  await replace(`/quan-ly/hop-dong/chi-tiet/${detailId}`);
};

const fetchHopDongDetailForEdit = async (detailId: number) => {
  try {
    const {
      data: {
        data: {
          bien_ban_kiem_nghiem,
          editable,
          ngay_ky,
          ten_doi_tac,
          dia_chi,
          so_dien_thoai,
          ngay_het_han,
          so_hoa_don,
          so_hop_dong,
          ma_so_thue,
          ma_ct,
          ma_tk,
          tk_ketoan,
          loai_hop_dong,
          hoan_thanh,
          hop_dong_vat_tu,
        },
      },
    } = await HopDongService.fetchContractDetail(detailId);

    if (!editable) {
      await swalErrNotification(null, "Không thể chỉnh sửa hợp đồng này");
      await redirectToHopDongDetail(detailId);

      return;
    }

    if (hoan_thanh === 1) {
      await swalErrNotification(
        null,
        "Không thể chỉnh sửa hợp đồng đã có biên bản kiểm nghiệm hoặc đã hoàn thành"
      );
      await redirectToHopDongDetail(detailId);

      return;
    }

    clearLines();

    contract.contractNumber = formatContractNumber(so_hop_dong);
    document.title = `${so_hop_dong} - Chỉnh sửa - ${formConfig.value.documentTitleSuffix} - Đường sắt Hà Nội`;
    contract.bien_ban_kiem_nghiem = bien_ban_kiem_nghiem;
    contract.signDate = new Date(ngay_ky).toISOString();
    contract.expiryDate = ngay_het_han
      ? new Date(ngay_het_han).toISOString()
      : "";
    isNoExpiration.value = !ngay_het_han;
    contract.phoneNumber = so_dien_thoai;

    if (tk_ketoan) {
      taiKhoanData.value = { ...tk_ketoan };
      applyTkKetoanToContract(tk_ketoan);
    } else {
      taiKhoanData.value = {
        id: 0,
        matk: ma_tk,
        mact: ma_ct,
        tentk: `${ma_tk}${ma_ct ? ` / ${ma_ct}` : ""}`,
      };
      contract.partnerName = ten_doi_tac;
      contract.taxNumber = ma_so_thue;
      contract.address = dia_chi;
    }

    if (!tk_ketoan?.dia_chi) {
      contract.address = dia_chi;
    }

    contract.loai_hop_dong = loai_hop_dong;
    contract.so_hoa_don = so_hoa_don;

    if (hop_dong_vat_tu?.length) {
      hydrateFromHopDongVatTu(hop_dong_vat_tu);
    }

    setCurrentPageTitle(`Hợp đồng ${contract.contractNumber}`);
  } catch (e) {
    await swalErrNotification(
      e,
      "Xin lỗi, có vẻ có lỗi xảy ra khi lấy thông tin hợp đồng để cập nhật"
    );

    // After "Đã hiểu": go to detail unless the hop đồng was not found (404)
    if (getHttpErrorStatus(e) === 404) {
      return;
    }

    await redirectToHopDongDetail(detailId);
  }
};

onMounted(async () => {
  setBreadcrumbLinks([
    {
      text: "Hợp đồng",
      routeData: {
        name: "danh-sach-hop-dong",
      },
    },
    ...(isCreating.value
      ? []
      : [
          {
            text: "Chi tiết",
            routeData: {
              name: "chi-tiet-hop-dong",
              params: {
                id: String(contractId.value),
              },
            },
          },
        ]),
    {
      text: formConfig.value.breadcrumbActionLabel,
    },
  ]);

  if (isCreating.value) {
    contract.signDate = moment(getGlobalDefaultDate()).format("YYYY-MM-DD");
    contract.expiryDate = moment().endOf("year").format("YYYY-MM-DD");
    document.title = `Tạo mới - ${formConfig.value.documentTitleSuffix} - Đường sắt Hà Nội`;
    setCurrentPageTitle(formConfig.value.pageTitle);
  } else {
    await fetchHopDongDetailForEdit(contractId.value);
  }

  await focusContractNumberInput();
  await fetchHopDongList();
});

watch(
  () => currentPage.value,
  () => {
    fetchHopDongList();
  }
);

watch(
  () => perPage.value,
  () => {
    nextTick().then(() => {
      if (currentPage.value === 1) {
        fetchHopDongList();

        return;
      }

      currentPage.value = 1;
    });
  }
);

/** Reload when table row actions navigate create ↔ edit or another edit id */
watch(
  () => [contractId.value, isCreating.value] as const,
  async ([nextId, creating], [prevId, prevCreating]) => {
    if (creating) {
      currentPage.value = resolveListPageForRoute(route.query, {
        isCreate: true,
      });
      return;
    }

    if (!nextId || (nextId === prevId && !prevCreating)) {
      return;
    }

    currentPage.value = resolveListPageForRoute(route.query, {
      isCreate: false,
    });
    resetWizard();
    await fetchHopDongDetailForEdit(nextId);
    await nextTick();
    await focusContractNumberInput();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmationDialog, {
      isDisplay: isConfirmationDialogOpen.value,
      size: "sm",
      title: "XÁC NHẬN",
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (isConfirmationDialogOpen.value = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (isConfirmationDialogOpen.value = false)),
      onOnConfirmButtonClick: onSubmit
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(confirmTitle.value), 1)
      ]),
      _: 1
    }, 8, ["isDisplay"]),
    _createVNode(PageContentBase, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(steps), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "wizard-step",
                    "data-wizard-type": "step",
                    "data-wizard-state": wizardStepState(item),
                    role: "button",
                    tabindex: "0",
                    onClick: ($event: any) => (onStepClick(item.id)),
                    onKeyup: _withKeys(($event: any) => (onStepClick(item.id)), ["enter"])
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("i", {
                        class: _normalizeClass(['wizard-icon', item.iconClass])
                      }, null, 2),
                      _createElementVNode("h3", _hoisted_8, _toDisplayString(item.label), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["svg-icon svg-icon-xl wizard-arrow", { last: index === _unref(steps).length - 1 }])
                    }, _hoisted_10, 2)
                  ], 40, _hoisted_6))
                }), 128))
              ])
            ])
          ]),
          _createVNode(_unref(ElForm), {
            ref_key: "formRef",
            ref: formRef,
            class: "form mt-6",
            model: contract,
            rules: validationRules.value,
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_unref(HopDongMetaStep), {
                contract: contract,
                "is-no-expiration": isNoExpiration.value,
                "tai-khoan-data": taiKhoanData.value,
                "loai-hop-dong-options": loaiHopDongOptions,
                "onUpdate:contract": patchContract,
                "onUpdate:isNoExpiration": onNoExpirationChange,
                onSelectTaiKhoan: onSelectTaiKhoan,
                onClearTaiKhoan: onClearTaiKhoan,
                onToggleNoExpiration: toggleNoExpiration,
                onFocusContractNumber: focusContractNumberInput,
                onFocusSignDate: focusSignDatePicker,
                onFocusExpiryDate: focusExpiryDatePicker,
                onFocusLoaiHopDong: focusLoaiHopDongSelect,
                onFocusSoHoaDon: focusSoHoaDonInput,
                onFocusTaxNumber: focusTaxNumberInput,
                onFocusPartnerName: focusPartnerNameInput,
                onFocusPhoneNumber: focusPhoneNumberInput,
                onFocusAddress: focusAddressInput,
                onSetRef: onSetMetaRef
              }, null, 8, ["contract", "is-no-expiration", "tai-khoan-data"]), [
                [_vShow, _unref(isMetaStep)]
              ]),
              _withDirectives(_createVNode(_unref(HopDongHdvtStep), {
                lines: _unref(lines),
                onRemoveLine: _unref(removeLine),
                onPatchLine: _unref(patchLine),
                onAddExisting: _unref(addExistingFromVatTu)
              }, null, 8, ["lines", "onRemoveLine", "onPatchLine", "onAddExisting"]), [
                [_vShow, _unref(isHdvtStep)]
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_unref(isHdvtStep))
                  ? (_openBlock(), _createBlock(ButtonCustom, {
                      key: 0,
                      classes: `rounded-none m-0`,
                      "button-type": _unref(ButtonsType).BACK,
                      "color-type": _unref(ButtonTypeColors).SECONDARY,
                      onClick: _unref(goBack)
                    }, {
                      "button-label": _withCtx(() => [
                        _createTextVNode("Quay lại")
                      ]),
                      _: 1
                    }, 8, ["button-type", "color-type", "onClick"]))
                  : _createCommentVNode("", true),
                (_unref(isMetaStep))
                  ? (_openBlock(), _createBlock(ButtonCustom, {
                      key: 1,
                      classes: `rounded-none m-0`,
                      "button-type": _unref(ButtonsType).FORWARD,
                      "color-type": _unref(ButtonTypeColors).PRIMARY,
                      onClick: goToHdvt
                    }, {
                      "button-label": _withCtx(() => [
                        _createTextVNode("Tiếp tục")
                      ]),
                      _: 1
                    }, 8, ["button-type", "color-type"]))
                  : _createCommentVNode("", true),
                (_unref(isMetaStep))
                  ? (_openBlock(), _createBlock(ButtonCustom, {
                      key: 2,
                      classes: `rounded-none m-0`,
                      "button-type": _unref(ButtonsType).SAVE,
                      "color-type": _unref(ButtonTypeColors).SUCCESS,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (onOpenConfirmationDialog(false)))
                    }, {
                      "button-label": _withCtx(() => [
                        _createTextVNode("Lưu")
                      ]),
                      _: 1
                    }, 8, ["button-type", "color-type"]))
                  : _createCommentVNode("", true),
                (_unref(isHdvtStep))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      (_unref(isCreating))
                        ? (_openBlock(), _createBlock(ButtonCustom, {
                            key: 0,
                            classes: `rounded-none m-0`,
                            "button-type": _unref(ButtonsType).ADD,
                            "color-type": _unref(ButtonTypeColors).PRIMARY,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (onOpenConfirmationDialog(true)))
                          }, {
                            "button-label": _withCtx(() => [
                              _createTextVNode("Lưu và tiếp tục")
                            ]),
                            _: 1
                          }, 8, ["button-type", "color-type"]))
                        : _createCommentVNode("", true),
                      _createVNode(ButtonCustom, {
                        classes: `rounded-none m-0`,
                        "button-type": _unref(ButtonsType).SAVE,
                        "color-type": _unref(ButtonTypeColors).SUCCESS,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (onOpenConfirmationDialog(false)))
                      }, {
                        "button-label": _withCtx(() => [
                          _createTextVNode("Lưu")
                        ]),
                        _: 1
                      }, 8, ["button-type", "color-type"]),
                      (_unref(isCreating))
                        ? (_openBlock(), _createBlock(ButtonCustom, {
                            key: 1,
                            classes: `rounded-none m-0`,
                            "color-type": _unref(ButtonTypeColors).WARNING,
                            "button-type": _unref(ButtonsType).REFRESH,
                            onClick: clearForm
                          }, {
                            "button-label": _withCtx(() => [
                              _createTextVNode("Nhập lại")
                            ]),
                            _: 1
                          }, 8, ["color-type", "button-type"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(HopDongTable, {
            "cur-page": _unref(currentPage),
            items: hopDongItems.value,
            "per-page": _unref(perPage),
            "selected-id": _unref(isCreating) ? 0 : contractId.value
          }, null, 8, ["cur-page", "items", "per-page", "selected-id"]),
          (_unref(totalItems) > 0)
            ? (_openBlock(), _createBlock(Pagination, {
                key: 0,
                page: _unref(currentPage),
                "page-size": _unref(perPage),
                total: _unref(totalItems),
                onChangePage: _cache[6] || (_cache[6] = (value) => (currentPage.value = value)),
                onChangePageSize: _cache[7] || (_cache[7] = (value) => (perPage.value = value))
              }, null, 8, ["page", "page-size", "total"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})